import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'cie-diagnostics',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'cie-diagnostics-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                    
                    {                           
                        transKey: 'breadcrumbs.cie-diagnostics-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "cie-diagnostics-index" */ '@/modules/configurations/catalogs/cie-diagnostics/views/Index.vue')
        },
        {
            path: 'create',
            name: 'cie-diagnostics-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'cie-diagnostics-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.cie-diagnostics-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.cie-diagnostics-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "cie-diagnostics-create" */ '@/modules/configurations/catalogs/cie-diagnostics/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'cie-diagnostics-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'cie-diagnostics-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.cie-diagnostics-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.cie-diagnostics-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "cie-diagnostics-edit" */ '@/modules/configurations/catalogs/cie-diagnostics/views/Edit.vue')
        }
    ]
}